import { FormControl, Input } from '@material-ui/core'
import Message from '../Message/Message'

const NumberInput = ({ value, setValue, label, error, name = '' }) => {
  const handleChange = (val) => {
    if (val < 0) {
      setValue(0)
    } else {
      setValue(val)
    }
  }

  return (
    <div className={error ? 'error' : ''}>
      <FormControl className="number-input">
        <Input
          name={name}
          type="number"
          disableUnderline={true}
          value={value}
          onChange={(e) => handleChange(e.target.value)}
        />

        {label && (
          <div className="num-label">
            <div>{label}</div>
          </div>
        )}
      </FormControl>
      {error !== '' && <Message variant="danger">{error}</Message>}
    </div>
  )
}

export default NumberInput
